import { t } from 'i18next';

import { ConfirmationDeleteDialog } from '@/components/delete-dialog';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { authenticationApi } from '@/lib/authentication-api';
import { redirectToSignIn } from '@/lib/auth-navigation';
import { authenticationSession } from '@/lib/authentication-session';

export default function SessionsPage() {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="space-y-6 w-full">
        <div>
          <h3 className="text-xl font-semibold">{t('Sessions')}</h3>
          <p className="text-sm text-muted-foreground">
            {t('Manage your active sessions across all devices.')}
          </p>
        </div>
        <Separator />
        <div className="space-y-4">
          <div>
            <h4 className="text-sm font-medium">
              {t('Revoke all sessions')}
            </h4>
            <p className="text-sm text-muted-foreground">
              {t(
                'This will sign you out from all devices, including the current one.',
              )}
            </p>
          </div>
          <ConfirmationDeleteDialog
            title={t('Revoke all sessions')}
            message={t(
              'Are you sure you want to revoke all sessions? You will be signed out from all devices.',
            )}
            entityName={t('sessions')}
            mutationFn={async () => {
              await authenticationApi.revokeAllSessions();
              authenticationSession.clearSession();
              redirectToSignIn();
            }}
            buttonText={t('Revoke all')}
            isDanger={true}
            showToast={false}
          >
            <Button variant="destructive">{t('Revoke all sessions')}</Button>
          </ConfirmationDeleteDialog>
        </div>
      </div>
    </div>
  );
}
